module.exports = __webpack_public_path__ + "fonts/Raleway-LightItalic.78efd1da.ttf";